import React from 'react';
import { Box, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DescriptionIcon from '@mui/icons-material/Description';
import { op } from 'theme';

const DescriptionCard = ({description}) => {
  return (
    <Box
      sx={{
        backgroundColor: op.bg.surface,
        border: `1px solid ${op.border}`,
        borderRadius: '10px',
        p: 2.5,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2,
        }}
      >
        <Box
          sx={{
            width: '40px',
            height: '40px',
            backgroundColor: op.violet.deep,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <DescriptionIcon sx={{ color: '#FFFFFF', fontSize: 22 }} />
        </Box>

        <Typography variant="h3" component="h2">
          Descripción del evento
        </Typography>
      </Box>

      {/* Content */}
      <Box
        sx={{
          color: 'text.primary',
          fontSize: '15px',
          lineHeight: 1.7,
          textAlign: 'left',
          '& h1, & h2, & h3': {
            color: 'text.primary',
            fontFamily: "'Space Grotesk', sans-serif",
            marginTop: '1em',
            marginBottom: '0.5em',
            textAlign: 'left',
          },
          '& p': {
            marginBottom: '1em',
            textAlign: 'left',
          },
          '& ul, & ol': {
            paddingLeft: '1.5em',
            marginBottom: '1em',
            textAlign: 'left',
          },
          '& li': {
            marginBottom: '0.5em',
            textAlign: 'left',
          },
          '& strong': {
            color: 'text.primary',
            fontWeight: 600,
          },
          '& a': {
            color: op.violet.text,
          },
          '& code': {
            backgroundColor: op.bg.elevated,
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '0.9em',
          },
        }}
      >
        {description ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {description}
          </ReactMarkdown>
        ) : (
          <Typography sx={{ color: 'text.secondary', textAlign: 'left' }}>
            No hay descripción disponible para este evento.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DescriptionCard;
